export default __webpack_public_path__ + "static/media/image-phone-and-keyboard.41ef99e0.jpg";